import { computed, defineComponent, onMounted, onUnmounted, onUpdated, ref } from 'vue';
import { Popover } from 'bootstrap';
import { useDateFormat } from '@/composables/dateFormat';
import { useStore } from 'vuex';
import { DownloadAction, DownloadGetter } from '@/store/download/download.module';
import { Download } from '@/store/download/download.model';
import LoadingComponent from '@/components/loading/Loading.vue';

export default defineComponent({
  name: 'DownloadTableComponent',
  components: {
    LoadingComponent,
  },
  emits: [
    'edit'
  ],
  setup: (_, context) => {
    const dateFormat = useDateFormat();
    const store = useStore();
    const downloads = computed<Download[]>(() => store.getters[DownloadGetter.ALL]);
    const isLoading = computed(() => store.getters[DownloadGetter.STATUS] === 'init' || store.getters[DownloadGetter.STATUS] === 'loading');
    const datatable = ref<HTMLTableElement>();
    const dtInstance = ref();
    const popoverList = ref<Popover[]>([]);

    onMounted(() => {
      store.dispatch(DownloadAction.FETCH)
        .then(() => updateDataTable());
    });

    onUpdated(() => updateDataTable());

    onUnmounted(() => {
      dtInstance.value?.destroy();
    });

    const updateDataTable = () => {
      Promise.resolve(initialPopover())
        .then(() => initialDataTable());
    };

    const initialDataTable = () => {
      Promise.resolve(dtInstance.value?.destroy())
        .then(() => {
          const dt = datatable.value as HTMLTableElement;
          if (!$.fn.dataTable.isDataTable(dt)) {
            dtInstance.value = $(dt).DataTable({
              language: {
                emptyTable: 'ไม่พบข้อมูล',
                info: 'แสดง _START_ ถึง _END_ จากจำนวนทั้งหมด _TOTAL_',
                infoEmpty: 'แสดง 0 ถึง 0 จากจำนวนทั้งหมด 0',
                infoFiltered: '(ค้นหาจากจำนวนทั้งหมด _MAX_)',
                lengthMenu: 'แสดงข้อมูล _MENU_',
                paginate: {
                  next: 'ถัดไป',
                  previous: 'ก่อนหน้า',
                  first: 'First',
                  last: 'Last'
                },
                search: 'ค้นหา:',
                zeroRecords: 'ไม่พบข้อมูลที่ค้นหา',
              }
            });
          }
        });
    };

    const initialPopover = () => {
      const popoverTriggerList = computed<HTMLElement[]>(() => [].slice.call(document.querySelectorAll('[data-bs-toggle="popover-item"]')) as HTMLElement[]);
      popoverList.value.map(element => element.hide());
      popoverList.value = popoverTriggerList.value?.map(element => new Popover(element, { trigger: 'hover', placement: 'right' }));
    };

    const selectedClick = (id: number) => {
      context.emit('edit', id);
    };

    const toggleClick = (id: number) => {
      const item = downloads.value.find(m => m.id == id);
      store.dispatch(DownloadAction.PINNING, {
        id: id,
        pined: !item?.pined,
      });
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'short');

    return {
      downloads,
      datatable,
      isLoading,
      selectedClick,
      toggleClick,
      thaiDate,
    };
  },
});

